import React, { useEffect, useState } from 'react';
import { 
    Container, Button, TextField, Select, MenuItem, InputLabel, FormControl,
    Table, TableBody, TableCell, TableHead, TableRow, Paper, Dialog,
    DialogTitle, DialogContent, DialogActions, Radio, FormControlLabel, Box,
    useMediaQuery
} from '@material-ui/core';
import { db } from '../../firebase';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import Footer from '../../Components/Footer';

const categories = ["Kegiatan", "Harian", "Bulanan","Tahunan","Mendesak"];
const jawabanOptions = ['A','B','C','D','E'];
const PER_PAGE = 5;

const formatDate = (dateObj) => {
    let d = new Date(dateObj.seconds ? dateObj.seconds*1000 : dateObj);
    let dd = String(d.getDate()).padStart(2,'0');
    let mm = String(d.getMonth()+1).padStart(2,'0');
    let yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
};

const Procurement = () => {
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(true);
    const [openForm,setOpenForm] = useState(false);
    const [search,setSearch] = useState('');
    const [editId,setEditId] = useState(null);
    const [formData,setFormData] = useState({
        judulTryout:'', soalUrl:'', jawabanUrl:'', jumlahSoal:10,
        jawabanBenar:[], waktuPengerjaan:'', deskripsi:'', kategori:''
    });
    const [currentPage,setCurrentPage] = useState(1);
    const history = useHistory();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(()=>{
        const unsubscribe = db.collection('tryout')
            .orderBy('created_at','desc')
            .onSnapshot(snapshot=>{
                const tryouts = snapshot.docs.map(doc=>({ id: doc.id, ...doc.data() }));
                setData(tryouts);
                setLoading(false);
            });
        return ()=>unsubscribe();
    },[]);

    const handleOpenForm = ()=>setOpenForm(true);
    const handleCloseForm = ()=>{
        setOpenForm(false);
        setEditId(null);
        setFormData(prev=>({...prev,jawabanBenar:[]}));
    };

    const handleChange = (e)=>{
        const { name, value } = e.target;
        setFormData(prev=>{
            let newData = {...prev,[name]:value};
            if(name==='jumlahSoal'){
                const length = Number(value) || 0;
                newData.jawabanBenar = Array.from({length}, (_,i)=> prev.jawabanBenar[i] || '');
            }
            return newData;
        });
    };

    const handleJawabanChange = (index,value)=>{
        const updated = [...formData.jawabanBenar];
        updated[index] = value;
        setFormData(prev=>({...prev,jawabanBenar:updated}));
    };

    const isFormValid = ()=>{
        return formData.judulTryout && formData.soalUrl && formData.jawabanUrl &&
               formData.waktuPengerjaan && formData.deskripsi && formData.kategori &&
               formData.jawabanBenar.length===Number(formData.jumlahSoal) &&
               !formData.jawabanBenar.some(j=>!j);
    };

    const handleSubmit = async ()=>{
        if(!isFormValid()) return alert("Lengkapi semua field dan jawaban sebelum menyimpan!");
        try{
            const currentDate = new Date();
            const newItem = {
                ...formData,
                created_at: editId ? formData.created_at : currentDate,
                modified_at: editId ? currentDate : null
            };
            if(editId){
                await db.collection('tryout').doc(editId).set(newItem);
            }else{
                await db.collection('tryout').doc().set(newItem);
            }
            handleCloseForm();
        }catch(err){
            console.error("Error menyimpan tryout:",err);
        }
    };

    const handleView = (item)=>history.push('/examer/'+item.id);
    const handleEdit = (item)=>{
        setEditId(item.id);
        setFormData({...item, jawabanBenar:item.jawabanBenar||[], created_at:item.created_at||new Date()});
        handleOpenForm();
    };
    const handleDelete = async (id)=>{
        if(!window.confirm("Apakah yakin ingin menghapus?")) return;
        await db.collection('tryout').doc(id).delete();
    };

    const filteredData = Array.isArray(data) ? data.filter(item=>item.judulTryout.toLowerCase().includes(search.toLowerCase())) : [];
    const maxPage = Math.ceil(filteredData.length/PER_PAGE);
    const currentData = Array.isArray(filteredData) ? filteredData.slice((currentPage-1)*PER_PAGE,currentPage*PER_PAGE) : [];

    return (
        <Container maxWidth="md">
            <h1 style={{fontSize:isMobile?'1.5rem':'2rem', textAlign:isMobile?'center':'left'}}>Procurement Management</h1>
                 <Button variant="contained" color="primary" onClick={handleOpenForm} fullWidth={isMobile}>
                    Tambah Catatan
                </Button>
            <Box display="flex" flexDirection={isMobile?'column':'row'} gap={2} alignItems={isMobile?'stretch':'center'}>

                <TextField 
                    label="Cari Catatan" 
                    value={search} 
                    onChange={e=>{setSearch(e.target.value); setCurrentPage(1)}} 
                    fullWidth margin="normal"
                />
            </Box>

            {/* Table scrollable */}
            <Paper style={{marginTop: 20, overflowX:'auto', height: 300}}>
                <Table stickyHeader size={isMobile?"small":"medium"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>No.</TableCell>
                            <TableCell>Tujuan Pengadaan</TableCell>
                            {!isMobile && <TableCell>Kategori</TableCell>}
                            <TableCell>Cash</TableCell>
                            {!isMobile && <TableCell>Tanggal Transaksi</TableCell>}
                            {!isMobile && <TableCell>Keterangan</TableCell>}
                            {!isMobile && <TableCell>Nota</TableCell>}
                            <TableCell>Aksi</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow><TableCell colSpan={6}>Loading...</TableCell></TableRow>
                        ) : currentData.length===0 ? (
                            <TableRow><TableCell colSpan={6}>Tidak ada data</TableCell></TableRow>
                        ) : (
                            currentData.map((item,index)=>(
                                <TableRow key={item.id} hover>
                                    <TableCell>{(currentPage-1)*PER_PAGE+index+1}</TableCell>
                                    <TableCell>{item.judulTryout}</TableCell>
                                    {!isMobile && <TableCell>{item.kategori}</TableCell>}
                                    <TableCell>{item.waktuPengerjaan} mnt</TableCell>
                                    {!isMobile && <TableCell>{formatDate(item.created_at)}</TableCell>}
                                     {!isMobile && <TableCell>{formatDate(item.created_at)}</TableCell>}
                                      {!isMobile && <TableCell>{formatDate(item.created_at)}</TableCell>}
                                    <TableCell>
                                        <Box display="flex" flexDirection={isMobile?'column':'row'} gap={1}>
                                            <Button size="small" color="primary" onClick={()=>handleView(item)}>Buka</Button>
                                            <Button size="small" color="secondary" onClick={()=> {
                                                // handleDelete(item.id) 
                                            }}>Delete</Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Paper>

            {/* Pagination */}
            <Box display="flex" justifyContent="center" flexWrap="wrap" marginTop={2} gap={1}>
                <Button disabled={currentPage===1} onClick={()=>setCurrentPage(currentPage-1)}>Prev</Button>
                {[...Array(maxPage)].map((_,i)=>(
                    <Button 
                        key={i+1} 
                        variant={currentPage===i+1?"contained":"outlined"} 
                        onClick={()=>setCurrentPage(i+1)} 
                        size={isMobile?"small":"medium"}
                    >
                        {i+1}
                    </Button>
                ))}
                <Button disabled={currentPage===maxPage} onClick={()=>setCurrentPage(currentPage+1)}>Next</Button>
            </Box>

            {/* Form Dialog */}
            <Dialog open={openForm} onClose={handleCloseForm} maxWidth="sm" fullWidth>
                <DialogTitle>{editId?"Edit Pengadaan":"Tambah Pengadaan"}</DialogTitle>
                <DialogContent>
                    <TextField label="Tujuan Pengadaan" name="judulTryout" value={formData.judulTryout} onChange={handleChange} fullWidth margin="normal"/>
                    <TextField label="Nota" name="soalUrl" value={formData.soalUrl} onChange={handleChange} fullWidth margin="normal"/>
                    <TextField label="Lokasi" name="jawabanUrl" value={formData.jawabanUrl} onChange={handleChange} fullWidth margin="normal"/>
                    <TextField label="Lampiran" type="number" name="waktuPengerjaan" value={formData.waktuPengerjaan} onChange={handleChange} fullWidth margin="normal"/>
                    <TextField label="Keterangan" name="deskripsi" value={formData.deskripsi} onChange={handleChange} fullWidth margin="normal" multiline/>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Kategori</InputLabel>
                        <Select name="kategori" value={formData.kategori} onChange={handleChange}>
                            {categories.map(cat=><MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <TextField label="Cash(TerBayar)" type="number" name="jumlahSoal" value={formData.jumlahSoal} onChange={handleChange} fullWidth margin="normal"/>

                    {/* Jawaban otomatis */}
                    {formData.jawabanBenar.map((_,i)=>(
                        <Box key={i} display="flex" flexWrap="wrap" alignItems="center" mb={1}>
                            <Box width={isMobile?"100%":"120px"} fontWeight="bold">Soal {i+1}</Box>
                            {jawabanOptions.map(opt=>(
                                <FormControlLabel 
                                    key={opt} 
                                    value={opt} 
                                    control={<Radio checked={formData.jawabanBenar[i]===opt} onChange={e=>handleJawabanChange(i,e.target.value)}/>} 
                                    label={opt} style={{marginRight:20}}
                                />
                            ))}
                        </Box>
                    ))}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseForm}>Batal</Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained" disabled={!isFormValid()}>Simpan</Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default Procurement;
